<template>
  <div>
    <div class="mb-2">
      <jade-text
        variant="text-medium"
        weight="medium"
        color="neutral"
      >
        {{ $t(computedDataByType.title) }}
      </jade-text>
    </div>
    <div>
      <emd-text
        v-if="showCurrency"
        color="#8B8B92"
        size="tiny"
        >R$</emd-text
      >
      <chart-line
        :data="computedDataByType.data"
        :yAxisOptions="computedDataByType.yAxisOptions"
        :tooltipConfig="computedDataByType.tooltipConfig"
        :xlabels="computedDataByType.xLabels"
      />
    </div>
  </div>
</template>

<script>
import { EmdText } from 'emerald-vue/src/components'
import ChartLine from '@/components/project/charts/line'

import MathManager from '@/utils/math-manager.utils'

import ChargesManager from './charges.manager'
import CHARGES_ENUM from './charge.enum'

import { JadeText } from '@jade'

export default {
  name: 'ChartLineCharges',
  components: {
    EmdText,
    ChartLine,
    JadeText
  },
  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      yAxisOptions: {
        format: MathManager.formatCurrency,
        currencySymbol: 'R$',
        currencyDisplay: false
      },
      tooltipConfig: {
        format: MathManager.formatCurrency,
        currencySymbol: 'R$',
        currencyDisplay: true
      }
    }
  },
  computed: {
    hasData () {
      return this.computedDataByType.data?.length > 0
    },
    computedDataByType () {
      return new ChargesManager(
        this.data.data,
        this.type,
        this.$route.query
      ).get()
    },
    showCurrency () {
      return this.type !== CHARGES_ENUM.SALES
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "total-traded-volume": "Volume total transacionado (TPV)",
      "total-authorized-volume": "Cobranças autorizadas (TPV)",
      "tippy-ticket": "Valor médio das compras feitas no seu site/app, calculado com base nas transações de status \"Paga\".",
      "charges-amount": "Número de cobranças",
      "ticket": "Ticket médio"
    },
    "en-US": {
      "total-traded-volume": "Total traded volume (TPV)",
      "total-authorized-volume": "Authorized charges (TPV)",
      "tippy-ticket": "Average value of purchases made on your website/app, calculated based on transactions with the status \"Paid\".",
      "charges-amount": "Number of charges",
      "ticket": "Average ticket"
    }
  }
</i18n>
